import AccountModel from 'common/core/models/Account'
import { AccountStatus } from 'common/core/models/Account/constants'

export const getAccountStatusLozenge = (accountStatus: AccountStatus) => {
  const isPro = AccountModel.isProOrTrialStatus(accountStatus)
  const isTrialStatus = AccountModel.isTrialStatus(accountStatus)

  if (isTrialStatus) {
    return 'trial'
  }
  return isPro ? 'pro' : 'free'
}
